import { getBadgeText } from "../getBadgeText";
import getPriceInfo from "./getPriceInfo";

const getAriaLabel = ({
  description,
  price,
  reducedPrice,
  isOutlet,
  discount,
  badgeType,
  hasMultiplePrices,
  formatTranslation
}) => {
  const priceInfo = getPriceInfo({
    price,
    reducedPrice,
    hasMultiplePrices,
    isOutlet,
    formatTranslation
  });
  const sections = [description, priceInfo];
  if (discount) {
    sections.push(
      `${formatTranslation("generic_accessibility_discount")}: -${discount}%`
    );
  }
  if (badgeType) {
    sections.push(getBadgeText({ type: badgeType, formatTranslation }));
  }

  return sections.join("; ");
};

export default getAriaLabel;
